import * as React from "react";
import { useContext, createContext, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import CustomNotificationsContext from "./CustomNotificationsContext";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

export const useNotificationContext = () => {
  return useContext(CustomNotificationsContext);
};

const CustomNotifications = ({ children }) => {
  const [notify, setNotify] = useState({
    open: false,
    severity: "",
    title: "",
    message: "",
  });
  const [severity, setSeverity] = useState("");

  const handleClose = () => {
    setNotify((prev) => {
      return {
        ...prev,
        open: false,
      };
    });
  };

  const error = (title, message) => {
    setNotify({
      open: true,
      severity: "error",
      title: title,
      message: message,
    });
  };

  return (
    <CustomNotificationsContext.Provider value={{ error }}>
      {children}
      <Snackbar
        open={notify.open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={notify.message}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert
          onClose={handleClose}
          severity={notify.severity}
          variant="filled"
          sx={{ width: "100%", display: "flex", fontBold: "bold" }}
        >
          <AlertTitle>{notify.title}</AlertTitle>
          {notify.message}
        </Alert>
      </Snackbar>
    </CustomNotificationsContext.Provider>
  );
};

export default CustomNotifications;
